import React from 'react';
import PropTypes from 'prop-types';

import PageContent from '../../components/Layout/PageContent';
import './NotFoundError.css';

const NotFoundError = ({ baseUrl }) => (
  <PageContent pageTitle="Page Not Found - FabFitFan">
    <div className="page-content">
      <article className="not-found-error">
        <h1>404</h1>
        <h2>We’re sorry! The page you are looking for cannot be found!</h2>
        <a href={baseUrl} className="btn-back-home">Go back home</a>
      </article>
    </div>
  </PageContent>
);

NotFoundError.defaultProps = {
  baseUrl: process.env.REACT_APP_SITE_URL,
};

NotFoundError.propTypes = {
  baseUrl: PropTypes.string,
};

export default NotFoundError;
